import RELATED_HEADERS from 'authJsonHeaders'

const fetchRelated = tag => {
  return fetch(`/soviet/advice_tags/${tag}/related`, { headers: RELATED_HEADERS })
    .then(res => res.ok ? res.json() : Promise.resolve([]))
    .catch(() => Promise.resolve([]))
}

export default fetchRelated
